import PropTypes from 'prop-types'
import React from 'react'
import { ErrorBoundary } from 'components'

import styles from './Layout.module.scss'

const Layout = ({ children }) => {
  const { content } = styles

  return (
    <ErrorBoundary>
      <div className={content}>{children}</div>
    </ErrorBoundary>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
